import { dispatchProps } from "../../../cnr/reducers/reducerHelpers/dispatchProps"
import { mergePromise } from "../../promises/mergePromise"
import { updateDocumentHelpers } from "./fsUpdate_document"

export const fsUpdate_updateSortedCollection = (props) => {

  const { pathViews, database_fns, baseRef, ufProps, dispatch } = props

  const { refPath, directCollection } = baseRef
  let { vit, sortedData, dataRestrictions, appDataSource } = ufProps ?? {}
  const { useAppDataDocuments, updateAppDataDocuments } = appDataSource ?? {}
  let _updateAppDataDocuments = updateAppDataDocuments || useAppDataDocuments

  if (dataRestrictions && (dataRestrictions.all || dataRestrictions.sortData)) {
    dispatch({ type: dispatchProps.successAlt, dispatch })
    return false
  }

  mergePromise(database_fns, refPath, vit, directCollection, sortedData).then(() => {
    if (_updateAppDataDocuments) {
      updateDocumentHelpers.update_itemsInDocument(database_fns, pathViews, vit, sortedData, _updateAppDataDocuments)
    }
    dispatch({ type: dispatchProps.success, dispatch })
  }).catch(error => {
    dispatch({ type: dispatchProps.error, error, dispatch })
  })
}